const FACTORS = [
  {
    step: "01", name: "Honest Self-Reflection",
    detail: "Mitigates social-desirability bias through non-judgmental, multi-choice scenarios.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/c4f95a398171612003c65b3828c5bf9f3b3fd7a8dbe6cb432307a22afe438d50.jpeg",
    accent: "indigo",
  },
  {
    step: "02", name: "Situational Context Sensitivity",
    detail: "Differentiates baseline personality traits from transient stress or exam pressure.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/29a2f21c8978e4a8c76ab16b42da18e21ccc275234b9a3e274e1479dc3d3478d.jpeg",
    accent: "cyan",
  },
  {
    step: "03", name: "Multi-Dimensional Trait Synthesis",
    detail: "Combines RIASEC interests, Big-Five traits and career-values into one holistic archetype.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/d15bf15c3e028504bef2d25ff1f5603e10ddf8fe7b259624d6a715c975721b0e.jpeg",
    accent: "violet",
  },
  {
    step: "04", name: "Standardized Psychometric Norms",
    detail: "Calibrated against research-grounded models to maintain statistical validity.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/e6948da8a2fd2594cf7b53b4bbb94858045b9fc1fc97d7ed995ab028b31a8ed4.jpeg",
    accent: "indigo",
  },
  {
    step: "05", name: "Age & Stage Adaptation",
    detail: "Custom-tailored scoring for high schoolers, undergraduates and early career pivots.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/8c0233887c451007024b266090fd2c9ffcadba069917c2c24df4c79aee5ebe72.jpeg",
    accent: "cyan",
  },
  {
    step: "06", name: "Continuous Academic Evolution",
    detail: "Report insight evolves as students complete milestones and acquire new competencies.",
    image: "https://static.prod-images.emergentagent.com/jobs/fba0d12f-f224-488d-926e-6afdb5e36f91/images/640f88e5288cf56dcde3af9b3b20dae1232c4da02a74702b0bb8cf42d259302c.jpeg",
    accent: "violet",
  },
];

const ACCENT_STYLES = {
  indigo: { glow: "bg-indigo-500/25", border: "hover:border-indigo-300 hover:shadow-indigo-100", ring: "from-indigo-100 via-indigo-50 to-transparent", num: "text-indigo-100" },
  cyan: { glow: "bg-cyan-400/25", border: "hover:border-cyan-300 hover:shadow-cyan-100", ring: "from-cyan-100 via-cyan-50 to-transparent", num: "text-cyan-100" },
  violet: { glow: "bg-violet-500/25", border: "hover:border-violet-300 hover:shadow-violet-100", ring: "from-violet-100 via-violet-50 to-transparent", num: "text-violet-100" },
};

export default function FactorsAffectingAccuracy() {
  return (
    <section className="bg-white py-24 px-6" data-testid="factors-affecting-accuracy-section">
      <div className="max-w-6xl mx-auto">
        <p className="text-xs uppercase tracking-[0.2em] font-medium text-indigo-600 mb-3 text-center">Assessment Depth</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 text-center max-w-3xl mx-auto mb-4">
          6 Core Factors Affecting Psychometric Assessment Accuracy & Depth
        </h2>
        <p className="text-base text-slate-600 text-center max-w-2xl mx-auto mb-16 leading-relaxed">
          A trustworthy assessment isn't just a set of questions — it's an engineered system. Here is what
          CareerStudy360 accounts for behind the scenes to keep your results meaningful.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {FACTORS.map((f) => {
            const a = ACCENT_STYLES[f.accent];
            return (
              <div
                key={f.step}
                data-testid={`factor-card-${f.step}`}
                className={`group relative overflow-hidden rounded-2xl border border-slate-100 bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${a.border}`}
              >
                <span className={`absolute -top-4 -right-2 font-heading text-6xl font-black select-none ${a.num}`}>{f.step}</span>
                <div className="relative z-10">
                  <div className="relative h-16 w-16 mb-5 flex items-center justify-center">
                    <span className={`absolute inset-0 rounded-full blur-xl scale-90 ${a.glow} transition-transform duration-300 group-hover:scale-110`} />
                    <img
                      src={f.image}
                      alt={f.name}
                      className="relative h-16 w-16 object-contain drop-shadow-md transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>
                  <h3 className="font-heading text-base font-semibold text-slate-900 mb-2">{f.name}</h3>
                  <p className="text-sm text-slate-500 leading-relaxed">{f.detail}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
